import PropTypes from 'prop-types'
import * as React from 'react'
import type {MouseEvent} from 'react'
import {wrapDisplayName} from 'recompose'

import {autobind} from '@base/decorators'
import {createOrCallElement} from '@base/react-utils'

/** Adds clearing behaviour to components

 Props:
 - clearable - indicates weather or nor component should be able to clear value

 */
export default function clearable(Component) {
  const decorated = Component
  decorated.propTypes = {
    clearable: PropTypes.bool,
    ...Component.propTypes,
  }

  decorated.defaultProps = {
    clearable: false,
    ...Component.defaultProps,
  }
  return decorated
}

export const genericHandleClearClick = (event: MouseEvent, props: any) => {
  event.stopPropagation()
  const {onValueChange, onClearClick} = props

  const clearValue = undefined

  if (onClearClick) onClearClick(event)
  if (onValueChange && !event.defaultPrevented) onValueChange(clearValue)
}

type Props = {
  clearable: boolean
  onClearClick?: (event: MouseEvent) => void
}

export const withClear = () => (Component: React.ComponentType<Props>) =>
  class Clearable extends React.Component<Props> {
    static displayName = wrapDisplayName(Component, 'withClear')

    static defaultProps = {
      clearable: false,
    }

    // @ts-ignore
    @autobind
    handleClearClick(event) {
      const {onClearClick, ...otherProps} = this.props
      genericHandleClearClick(event, otherProps)
    }

    render() {
      const {
        clearable, // eslint-disable-line @typescript-eslint/no-shadow
        ...otherProps
      } = this.props

      return createOrCallElement(Component, {
        ...otherProps,
        clearable,
        onClearClick: this.handleClearClick,
      })
    }
  }
